// removed by extract-text-webpack-plugin
module.exports = {"dndBucketFooter":"dndBucketFooter__dndBucketFooter___31wc8 print__printHidden___3GLMT","list":"dndBucketFooter__list___1sAUK"};


//////////////////
// WEBPACK FOOTER
// ./src/styles/components/lib/tables/dnd/dndBucketFooter.css
// module id = 1494
// module chunks = 0